import { render, staticRenderFns } from "./After.vue?vue&type=template&id=87b51bf4&scoped=true"
import script from "./After.vue?vue&type=script&lang=js"
export * from "./After.vue?vue&type=script&lang=js"
import style0 from "./After.vue?vue&type=style&index=0&id=87b51bf4&prod&scoped=scoped&lang=less"
import style1 from "./After.vue?vue&type=style&index=1&id=87b51bf4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b51bf4",
  null
  
)

export default component.exports